import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/apiClient';

interface ConvertLeadInput {
  name: string;
  phone: string;
  whatsappJid?: string;
  email?: string;
  age?: number;
  gender?: string;
  goal?: string;
}

interface ConvertLeadResponse {
  success: boolean;
  message: string;
  duplicate?: boolean;
  client?: {
    id: string;
    name: string;
    phone: string;
    status?: string | null;
    whatsapp_jid?: string;
  };
}

export function useConvertLead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ConvertLeadInput) => {
      if (!payload.whatsappJid) {
        throw new Error('WhatsApp JID is required to convert lead');
      }

      const { data } = await api.post<ConvertLeadResponse>(
        `/api/whatsapp/leads/${encodeURIComponent(payload.whatsappJid)}/convert`,
        {
          name: payload.name,
          phone: payload.phone,
          email: payload.email,
          age: payload.age,
          gender: payload.gender,
          goal: payload.goal,
        }
      );
      return data;
    },
    onSuccess: () => {
      // Invalidate both clients and chats queries to refresh the UI
      queryClient.invalidateQueries({ queryKey: ['clients'] });
      queryClient.invalidateQueries({ queryKey: ['whatsapp', 'chats'] });
    },
  });
}
